import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import HtmlUnderline from './icon-html-underline.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <HtmlUnderline {...validProps} />;
}
SvgComponent.iconName = 'html-underline';

/**
 * @deprecated This is a legacy icon
 */
export const HtmlUnderlineIcon = svgIconWrapper(SvgComponent);
